<!-- 파트너 의뢰 상세정보 -->
<template>
  <div>
    <admin-box-item title="파트너 의뢰" :useTab="false">
      <div class="columns is-multiline" style="padding-bottom: 20px">
        <div class="column is-full">
          <admin-form-item label="파트너">
            <div>{{ partnerName }}</div>
          </admin-form-item>
        </div>

        <div class="column is-full">
          <admin-form-item label="내용">
            <div>{{ value.requestItem.note }}</div>
          </admin-form-item>
        </div>

        <div class="column is-full">
          <admin-form-item label="첨부파일">
            <div v-for="file in value.requestItem.files" class="lp-est-content">
              <div @click="openFile(file)" class="flex flex-center unselect"
                   style="cursor:pointer"><i class="material-icons" style="font-size:16px">attach_file</i><div>{{ fileName(file) }}</div></div>
            </div>
          </admin-form-item>
        </div>

      </div>
    </admin-box-item>
  </div>
</template>

<script>

  import AdminFormItem from "../admin/AdminFormItem";
  import LpAdmDropInput from "../common/LpAdmDropInput";
  import InputFile from "../common/InputFile";

  export default {
    props: ['data'],
    components: {
      InputFile,
      LpAdmDropInput,
      AdminFormItem
    },
    data() {
      return {
        value: {

        },
        partners:[],
        errMsg:''
      }
    },
    computed: {
      partnerName(){
        let partner_id;
        if(this.value.requestItem){
          partner_id = this.value.requestItem.partner_id;
        }

        let partner = find(this.partners, 'value', partner_id);
        if(partner !== undefined)
          return partner.name;
        else
          return '';
      }
    },
    created() {
      this.value = this.data;
      if(this.$store.getters.mode==='admin') {
        this.$axios.get('admin/partner/simple').then(res => {
          this.partners = res.data;
        })
      }
    },
    watch: {
      data(n) {
        if (n) {
          this.value = n;
        }
      }
    },
    methods: {
      cancelModal(){
        this.$store.commit('cancelModal');
      },
      fileName(file){
        return file.split('/')[file.split('/').length-1];
      },
      openFile(path){
        let link = document.createElement('a');
        let filename = path;
        //let filename = path;
        link.download = filename;
        window.open(filename);
        link.click();

      },
    }
  }
</script>
<style lang="stylus" type="stylus" scoped>

</style>
